var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0.263674693%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B816",
    offset: "99.934016%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beispiel",
    transform: "translate(-764.000000, -196.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789,196 C802.807119,196 814,207.192881 814,221 C814,234.807119 802.807119,246 789,246 C775.192881,246 764,234.807119 764,221 C764,207.192881 775.192881,196 789,196 Z M787.021856,208.107422 C780.624285,208.928543 776,214.684289 776,221.13432 L776,227.038442 C776,230.833909 777.457299,233.384615 779.626374,233.384615 L785.065934,233.384615 L785.065934,220.692269 L779.626374,220.692269 C779.626374,215.693585 783.693619,211.626343 788.692308,211.626343 C793.690996,211.626343 797.758242,215.693585 797.758242,220.692269 L792.318681,220.692269 L792.318681,233.384615 L797.758242,233.384615 C799.927316,233.384615 801.384615,230.833857 801.384615,227.038391 L801.384615,220.692269 C801.384615,213.14411 794.761839,207.113973 787.021856,208.107422 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialAudio);
export default __webpack_public_path__ + "static/media/special_audio.eb890115496d3c93f4fcc121bbc99005.svg";
export { ForwardRef as ReactComponent };